// extracted by mini-css-extract-plugin
export default {"dots_container":"shimmer_dots_container__F6Xf9","dot":"shimmer_dot__M7In8","pulse":"shimmer_pulse__5FOD6"};